<template>
	<div class='earnings'>
		<div
			class="block"
			v-loading="loading"
		>
			<el-date-picker
				ref="picker"
				@change="onChange"
				:clearable="false"
				v-model="value"
				value-format="yyyy-MM"
				type="month"
				placeholder="选择月"
			>
			</el-date-picker>

			<div class="money_box">
				<div class="item">
					<span class="money_span">收入 (元)</span>
					<span
						style="color: #FF5548;"
						class="amount"
					>{{amountData.inAmount || 0}}</span>
				</div>
				<div class="item">
					<span class="money_span">提现 (元)</span>
					<span class="amount">{{amountData.withdrawCashAmount || 0}}</span>
				</div>
				<div class="item">
					<span class="money_span">支出 (元)</span>
					<span class="amount">{{amountData.outAmount || 0}}</span>
				</div>
			</div>

			<div class="conter_box">
				<div
					:class="['record', !i ? 'bor_top' : '']"
					v-for="(el,i) in dataList"
					:key="i"
				>
					<div
						class=""
						style="display: flex;align-items: center;"
					>
						<img
							v-if="el.faType === 2"
							:src="$store.state.onlineBasePath + 'group1/M00/12/52/L2rchmSdQHuAbzNkAAAJA2RA4hA578.png'"
							mode=""
						>
						<img
							v-else
							:src="$store.state.onlineBasePath + 'group1/M00/12/52/L2rchmSdT4qABm4wAAALUOH112A841.png'"
							mode=""
						>

						<div class="">
							<div class="goods_name">{{el.productSubject || el.faName}}</div>
							<div class="goods_time">{{ el.createTime }}</div>
						</div>
					</div>
					<div class="price_box">
						<span style="margin-right: 5px;">{{el.faType === 1? '+' : '-'}}{{el.amount}}</span>
					</div>
				</div>

				<div
					class="kong"
					v-if="dataList.length == 0"
				>
					<img
						:src="$store.state.wqurl + 'all_page_nullTowImg.png'"
						alt=""
					>

					暂无数据
				</div>
			</div>
		</div>
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="page"
				layout="prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  selectCashWithdrawSum,
  selectCashWithdraw,
} from "@/api/professionServer";
export default {
  name: "earnings",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      value: new Date(),
      amountData: "",
      dataList: [],
      page: 1,
      total: 0,
      loading: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onChange() {
      this.selectCashWithdraw();
      this.selectCashWithdrawSum();
    },

    async selectCashWithdrawSum() {
      const res = await selectCashWithdrawSum({ yearMonth: this.value });
      if (res.code !== 200) return;
      this.amountData = res.data;
    },

    async selectCashWithdraw(reset = true) {
      try {
        this.loading = true;
        if (reset) {
          this.page = 1;
          this.dataList = [];
        }
        const data = {
          page: this.page,
          limit: 15,
          yearMonth: this.value,
        };
        const res = await selectCashWithdraw(data);
        this.loading = false;
        if (res.code !== 200) return;
        this.dataList = res.data.data;
        this.total = res.data.total;
      } catch (error) {
        this.loading = false;
      }
    },

    handleCurrentChange(val) {
      this.page = val;
      this.dataList = [];
      this.selectCashWithdraw(false);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.selectCashWithdrawSum();
    this.selectCashWithdraw();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.earnings {
  height: 100%;
  .block {
    height: calc(100% - 40px);
    overflow: auto;
  }
  .money_box {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      .money_span {
        font-size: 12px;
        color: #999999;
      }
      .amount {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
    }
  }

  .conter_box {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .record {
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px #f0f0f0 solid;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 40px;
        margin-right: 18px;
      }

      .goods_name {
        font-size: 15px;
        color: #333333;
        margin-bottom: 10px;
      }

      .goods_time {
        font-size: 12px;
        color: #999999;
      }

      .price_box {
        font-size: 17px;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;
      }
    }

    .bor_top {
      border-top: 1rpx #f0f0f0 solid;
    }
  }
  ::v-deep .el-input__inner {
    cursor: pointer;
    border-color: transparent !important;
  }

  .kong {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    gap: 10px;
    color: #a6a9b1;
    justify-content: center;
    height: 100%;
    width: 100%;

    img {
      margin-top: 20%;
      width: 110px;
    }
  }

  .pagination {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
  }
}
</style>